import { render, staticRenderFns } from "./goodssale.vue?vue&type=template&id=6fb84402&scoped=true&"
import script from "./goodssale.vue?vue&type=script&lang=js&"
export * from "./goodssale.vue?vue&type=script&lang=js&"
import style0 from "./goodssale.vue?vue&type=style&index=0&id=6fb84402&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6fb84402",
  null
  
)

export default component.exports